import {Box} from '@mui/material';
import {makeStyles} from '@mui/styles';
import React from 'react';
import {useHistory} from 'react-router-dom';
import {initialUrl} from 'shared/configs/AppConst';
import AppLogo from '../AppLogo';

const HeaderLogo: React.FC = () => {
  const useStyles = makeStyles(() => ({
    logoRoot: {
      display: 'flex',
      flexDirection: 'row',
      cursor: 'pointer',
      alignItems: 'center',
    },
    logo: {
      marginTop: 0,
    },
  }));
  const classes = useStyles();
  const history = useHistory();

  const onLogoClicked = () => {
    history.push(initialUrl);
  };

  return (
    <Box className={classes.logoRoot} onClick={onLogoClicked}>
      <AppLogo className={classes.logo} />
    </Box>
  );
};

export default HeaderLogo;
